import { dreamService } from "motw_core/Services/DreamService";
import * as React from "react";
import { activeDreamFilterStyle } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Filters/Helpers/ActiveDreamFilterClass";
import { clearedDreamFilters } from "source/app/presentation/MainPanel/Dreams/DreamFilterButtons/Helpers/clearedDreamFilters";
import Dreams from "source/app/presentation/MainPanel/Dreams/Dreams";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render from "source/app/presentation/Shared/Render";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { AreDreamsFiltered } from "../../Helpers/AreDreamsFiltered";
import { IDreamsState } from "../../IDreamsState";
import { DreamsMaxIcon } from "../Indicators/DreamsMaxIcon";
import { DreamsOverloadIcon } from "../Indicators/DreamsOverloadIcon";
import { hashTagsService } from "motw_core/Services/HashTagsService";
import { hashTag_thisweek } from "motw_core/Constants/constants";
import { ActivateDreamHashTag } from "../../HashTags/Link/Helpers/ActivateDreamHashTag";
import { NavigateToDreamsRoute } from "../../Routing/DreamsRouting";
import IDream from "motw_core/Entity/IDream";
import { EDragDropObject } from "source/app/services/Shared/EDragDropObject";
import { useDropTarget } from "source/app/services/Shared/Hooks/useDropTarget";
import { HandleThisWeekDropAsync } from "../../HashTags/Link/HandleHashTagLinkDropAsync";

export function ShowThisWeek({ dreams }: { dreams: Dreams }) {
    const dropTargetResult = useDropTarget<IDream>(
        [EDragDropObject.dreamRow],
        HandleThisWeekDropAsync
    );
    const thisWeeksDreams = dreams.state.dreamsdata.filter((dream) =>
        hashTagsService.DoesDreamHaveHashTag(dream, hashTag_thisweek)
    );

    const dreamCount = dreams ? thisWeeksDreams.length : 0;
    const textToDisplay = `This week (${dreamCount})`;

    return (
        <span
            ref={dropTargetResult.dropTargetRef}
            style={{
                color: `goldenrod`,
                fontWeight: dropTargetResult.isOver ? "bold" : "initial",
            }}
            {...ActiveDreamFilterClass(dreams)}
        >
            <IconWithText
                iconSuffix={EGlyphicon.bishop}
                whenClicked={() => LoadDreamsThisWeek()}
                displayAsBlock={false}
            >
                {textToDisplay}
            </IconWithText>
            <Render
                id="todayDreamsIcons"
                when={dreams.state.dreamsdata.length > 0}
            >
                <DreamsMaxIcon shouldDisplay={dreamCount === 10} />
                <DreamsOverloadIcon shouldDisplay={dreamCount > 10} />
            </Render>
        </span>
    );
}

export function LoadDreamsThisWeek() {
    const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

    if (dreams) {
        NavigateToDreamsRoute(`ThisWeek`);
        ActivateDreamHashTag(hashTag_thisweek);
    }
}

function ActiveDreamFilterClass(dreams: Dreams) {
    const isFilterActive =
        AreDreamsFiltered(dreams.state) &&
        dreams.state.searchText === hashTag_thisweek;

    const className = isFilterActive ? activeDreamFilterStyle : ``;
    return { className };
}
